import React, { useEffect, useState } from "react";
import Header from "../../../SharedFiles/Header/Header";
import Footer from "../../../SharedFiles/Footer/Footer";
import { toast, Toaster, } from 'react-hot-toast';
import { BiArrowBack } from 'react-icons/bi';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { BarLoader, CircleLoader, ClimbingBoxLoader, FadeLoader, HashLoader, PacmanLoader, PuffLoader, RingLoader, ScaleLoader } from "react-spinners";
import ProductionFgTiles from './ProductionFgTiles';
import { GetPoData, GetPOINVPINPUT, GETPRODISSUE, GETPRODRECEIPT, GetTransaction } from "../../../APIServices/ProductionService/ProductionFgService/ProductionFgThunk";
import ProductionTransfer from "./ProductionTransfer";
import { HashLoader } from "react-spinners";
import ProductionFgPost from "./ProductionFgPost";
import { showNavigateConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";
import SearchIcon from "@mui/icons-material/Search";
import TablePagination from "@mui/material/TablePagination";
import { commonFilter } from "../../../SharedFiles/Helper/utils";
import { useTranslation } from 'react-i18next';
import { useQRModal } from "../../../../Context/QrContext";

const ProductionFgMain = () => {
  const [tableBody, setTableBody] = useState([]);
  const [selectedbatch, setSelectedBatch] = useState([]);
  const [selectedAllbatch, setSelectedAllBatch] = useState([]);
  const [transferModal, setTransferModal] = useState(false);
  const [batchItem, setBatchItem] = useState("");
  const [batchDocEntry, setBatchDocEntry] = useState("");
  const [batchInfo, setBatchInfo] = useState({ itemCode: '', docEntry: '', plannedQty:'' });
  const [dataUpdate, setDataUpdate] = useState(false);
  const [getValues, setGetValues] = useState([]);
  const [showReceipt, setShowReceipt] = useState(false);
  const [openManual, setOpenManual] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [openAddBatch, setOpenAddBatch] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [InProgress, setInProgress] = useState(
    { INVPINPUTCall: false, PorReceiptCall: false, ProdReceiptCall: false});
  const {
    POINVPINPUT,
    ProductionFGReceipt,
    ProdFgData,
    ProductionFGIssue,
    ProdTransList,
    error,
    loading } = useSelector((state) => state.ProductionFg);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
const {PrintLabel,setPrintedRows} = useQRModal();

  const handleReceiptClick = (item) => {
    // setBatchDocEntry(item.docEntry);
    setBatchInfo({
      itemCode: item.item_Code,
      docEntry: item.docEntry,
    });
    dispatch(GETPRODISSUE({ DocEntry: item.docEntry }))
    dispatch(GetTransaction({DocEntry:item.docEntry}))
    setInProgress({ ...InProgress, PorReceiptCall: true });
    setDataUpdate(true);
  }

  const isLoading = () => {
    return (
      loading.POINVPINPUT ||
      loading.POINVPINPUTPost ||
      loading.ProdFgData ||
      loading.ProductionFGIssue ||
      loading.ProductionFGReceipt 
    );
  };
  const handleTransferClick = async (item) => {
    setOpenManual(false);    
    const DocEntry = item.docEntry;
    // setBatchItem(item.item_Code);
    // setBatchDocEntry(item.docEntry);
    setBatchInfo({
      itemCode: item.item_Code,
      docEntry: item.docEntry,
      plannedQty: item.planned_Qty,
    });
    // Set the flag to indicate that the API call is in progress
    setInProgress({ ...InProgress, INVPINPUTCall: true });
    dispatch(GetPOINVPINPUT({ DocEntry: DocEntry }));
  };

  const Checker = () => {
    if (InProgress.INVPINPUTCall && error.POINVPINPUTError) {
      setInProgress({ ...InProgress, INVPINPUTCall: false });
      toast.error(t('There is no transfer found for this item'));
    }
    if (InProgress.INVPINPUTCall && POINVPINPUT && !loading.POINVPINPUT) {
      // Open the modal if there is data in DisassembleBatch
      setInProgress({ ...InProgress, INVPINPUTCall: false });
      setTransferModal(true);
    }
    if (InProgress.PorReceiptCall && error.ProdIssueError) {
      setInProgress({ ...InProgress, PorReceiptCall: false });
      toast.error(t('There is no receipt found for this item'));
    } else if (InProgress.PorReceiptCall && ProductionFGIssue && !loading.ProductionFGIssue) {
      setInProgress({ ...InProgress, PorReceiptCall: false });
      setSelectedBatch(ProductionFGIssue[0]);
      setSelectedAllBatch(ProductionFGIssue);
      dispatch(GETPRODRECEIPT({ DocEntry: ProductionFGIssue[0].pur_Num }))
      setShowReceipt(true);
      setDataUpdate(true);

    }
    if (InProgress.ProdReceiptCall && error.ProductionFGReceiptError) {
      setOpenAddBatch(true);
      setInProgress({ ...InProgress, ProdReceiptCall: false });
      const errorPost = error.ProductionFGReceiptError;
      if (errorPost.errorCode) {
        toast.error(errorPost.errorMessage);
      } else {
        toast.error(t("Can't post receipt data"));
       
      }
   
    }
    if (InProgress.ProdReceiptCall && ProductionFGReceipt === 'Success') {
      toast.success(t('Posted successfully'));
      setOpenAddBatch(false);
      setInProgress({ ...InProgress, ProdReceiptCall: false });
      const currentDate = new Date().toLocaleDateString();
      const data = {
        Order_Number: getValues.order_Num,
        batch_Number: getValues.batch_Number,
        item_Code: getValues.item_Code,
        item_Name: getValues.item_Name,
        Actual_Weight: `${getValues.Weight}, Qty - ${getValues.quantity_Nos}`,
        CreatedDate:currentDate
      }
      
      PrintLabel(data,null,"ProductionFG","")
      dispatch(GetTransaction({DocEntry:batchInfo.docEntry}))
      setShowReceipt(false);
      setGetValues([])
      dispatch(GetPoData());
    }
  }
  useEffect(() => {
    Checker(); // Call batchChecker every time DisassembleBatch or error changes
  }, [POINVPINPUT, ProductionFGReceipt, loading, error, InProgress]);



  const handleSearchChange = (e) => {
    let value = e.target.value;
    setSearchValue(value);
    if (value) {
      // Perform search on 'order_No' field
      const filtered = commonFilter(ProdFgData, "order_No", value);
      setFilteredData(filtered);
      setPage(0); // Reset to first page when search value changes
    } else {
      setFilteredData(ProdFgData); // If no search, show all data
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page is changed
  };
const baseData = Array.isArray(filteredData) && filteredData.length > 0
  ? filteredData
  : Array.isArray(ProdFgData)
    ? ProdFgData
    : [];
  // Calculate the current data for pagination (based on search)
  const currentData =[...baseData]
  .sort((a, b) => {
    const aCondition = a.receipt_Count < a.planned_Qty && a.count > 0;
    const bCondition = b.receipt_Count < b.planned_Qty && b.count > 0;

    // Return -1 if a should come before b, 1 if after, or 0 if equal
    if (aCondition && !bCondition) return -1;
    if (!aCondition && bCondition) return 1;
    return 0;
  })
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleBackTiles = () => {
    // if (tableBody.length > 0) {
      showNavigateConfirmation(() => {
        setShowReceipt(false);
        setPrintedRows([]);
      })
      // });
    // } else {
    //   setShowReceipt(false);
    // }
  };

  const handleBack = () => {
    setTransferModal(false);
    setShowReceipt(false);
    setPrintedRows([]);
    navigate("/production/");
  };
  return (
    <>
      {/* <Header /> */}
      <div className="container mainDiv">
        <div className="col-12 gap-1 mb-4 d-flex align-items-center justify-content-between">
          <button onClick={() => (showReceipt ? handleBackTiles() : handleBack())} className="goBackButton gap-2 d-flex">
            <BiArrowBack size={24} />
          </button>
          {!showReceipt && (
            <div className="search-container d-flex align-items-center justify-content-center flex-grow-1">
              <div className="search-bar-container position-relative d-flex">
                <input
                  className="search-field"
                  value={searchValue}
                  onChange={(e) => handleSearchChange(e)}
                  placeholder={t('Search...')}
                />
                <SearchIcon className="search-icon position-absolute" />
              </div>
            </div>
          )}

          <p className="m-0 fw-medium mx-3">{t('PRODUCTION FG')}</p>
        </div>
        {showReceipt ? (
          <div>
            <ProductionFgPost
              setDataUpdate={setDataUpdate}
              dataUpdate={dataUpdate}
              selectedbatch={selectedbatch}
              setSelectedBatch={setSelectedBatch}
              selectedAllbatch={selectedAllbatch}
              InProgress={InProgress}
              setInProgress={setInProgress}
              setTableBody={setTableBody}
              setGetValues={setGetValues}
              getValues={getValues}
              tableBody={tableBody}
              setOpenAddBatch={setOpenAddBatch}
              openAddBatch={openAddBatch}
            />

          </div>
        ) : (
          <div className="sub-div">
            {searchValue && filteredData.length === 0 ? (
              <div
                className="no-data-message"
                style={{ textAlign: "center", marginTop: "20px" }}
              >
                <p>No data found</p>
              </div>
            ) : (
              <ProductionFgTiles
                currentData={currentData}
                // filteredData={filteredData}
                handleReceiptClick={handleReceiptClick}
                handleTransferClick={handleTransferClick}
              />
            )}
            {/* </div> */}
            <ProductionTransfer
              openManual={openManual}
              setOpenManual={setOpenManual}
              transferModal={transferModal}
              setTransferModal={setTransferModal}
              batchInfo ={batchInfo}/>
              {/* batchItem={batchItem}
              batchDocEntry={batchDocEntry}  */}
          </div>
        )}
        <Toaster
          position="top-center"
          toastOptions={{
            style: { fontSize: '16px', padding: '16px', width: '400px', borderRadius: '8px' },
          }}
        />
        {!showReceipt && (
          <TablePagination
            component="div"
            count={
              filteredData.length > 0
                ? filteredData?.length
                : ProdFgData?.length
            }
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Rows per page"
          />
        )}
      </div>
      <Footer />
      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}

    </>
  );
};

export default ProductionFgMain;

